

















































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {CargaSaraiva} from '@/model/resource/CargaSaraiva'
import {CargaSaraivaCollection} from '@/model/collection/CargaSaraivaCollection'
import {ListCargaSaraivaSchema} from '@/schema/resource/CargaSaraiva/ListCargaSaraivaSchema'
import {CsvCargaSaraivaSchema} from '@/schema/resource/CargaSaraiva/CsvCargaSaraivaSchema'

@Component
export default class ListCargaSaraivaView extends Mixins(MixinQueryRouter) {
  schema = new ListCargaSaraivaSchema()
  collection = new CargaSaraivaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: CargaSaraiva) {
    Helper.pushByName('editCargaSaraiva', item.$id)
  }

  async removeItem(item: CargaSaraiva) {
    await new DialogRemove(item).confirm(() => item.removeCargaSaraiva())
    await this.collection.listCargaSaraiva()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CargaSaraivaCollection().clearFilters().addFilter(params)

    await csv.listCsvCargaSaraiva()
    new CsvCargaSaraivaSchema().downloadCsv(csv.all())
  }
}
